import React, {useState} from "react"
import {useSelector, useDispatch} from "react-redux"

import {setLeftWorkAreaState} from "../../../redux/actions/product2dActions"

import "./leftworkaddtext.scss"

/**
 * Form for adding text
 * @component
 * @example
 * return (
 *  <FormAdd />
 * )
 */

const FormAdd = () => {
  const [text, setText] = useState("")
  const dispatch = useDispatch()
  /**
   * api instnts from redux
   */
  const makFabric = useSelector(state => state.makFabric)
  /**
   * Set text to local state
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleChange = ({target}) => setText(target.value)
  /**
   * Add text to canvas
   * @param {object} e - element
   */
  const handleAddText = e => {
    e.preventDefault()
    if (text.trim() === "") return
    if (makFabric) {
      setText("")
      makFabric.addText(text)
      dispatch(setLeftWorkAreaState("EDIT_TEXT"))
    }
  }

  return (
    <div className="leftWorkAddTextFormContainer">
      <div className="leftWorkAddTextInptContainer">
        <form onSubmit={handleAddText}>
          <textarea
            className="leftWorkAddTextText"
            type="text"
            value={text}
            placeholder="Enter text"
            onChange={handleChange}
          ></textarea>
          <button onSubmit={handleAddText} className="leftWorkAddTextBtn">
            add text
          </button>
        </form>
      </div>
    </div>
  )
}

export default FormAdd
